export default {
  MemberShowcase: () => import('./member.json'),
  AmethystShowcase: () => import('./amethyst.json'),
  AquamarineShowcase: () => import('./aquamarine.json'),
  DiamondShowcase: () => import('./diamond.json'),
  EmeraldShowcase: () => import('./emerald.json'),
  OpalShowcase: () => import('./opal.json'),
  RubyShowcase: () => import('./ruby.json'),
  SapphireShowcase: () => import('./sapphire.json'),
  TopazShowcase: () => import('./topaz.json'),
  VipShowcase: () => import('./vip.json'),
};
